import React, { PureComponent } from "react";
import { Modal, Button } from "react-bootstrap";
import { bootstrapUtils } from "react-bootstrap/lib/utils";

bootstrapUtils.addStyle(Button, "orange");

class CreateGameModal extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      game_name: "",
      course_id: 0,
      number_of_students: "",
      loading: false,
      showError1: false,
      showError2: false,
      showError3: false
    };
  }

  changeInput = e => {
    const input = e.target;

    this.setState({
      [input.name]: input.value
    });
  };

  changeSelect = e => {
    const select = e.target;
    let value = parseInt(select.value, 10);
    if (isNaN(value)) {
      value = 0;
    }

    this.setState({
      [select.name]: value
    });
  };

  submit = () => {
    const { game_name, course_id, number_of_students } = this.state;

    if (game_name === "") {
      this.setState({
        showError1: true,
        showError2: false,
        showError3: false
      });

      return;
    }

    if (course_id < 1) {
      this.setState({
        showError1: false,
        showError2: true,
        showError3: false
      });

      return;
    }

    let number = parseInt("0" + number_of_students, 10);
    if (isNaN(number)) {
      number = 0;
    }

    if (number < 1) {
      this.setState({
        showError1: false,
        showError2: false,
        showError3: true
      });

      return;
    }

    this.setState({
      loading: true,
      showError1: false,
      showError2: false,
      showError3: false
    });
    this.props.createGame(game_name, course_id, number, this.after_submit);
  };

  after_submit = () => {
    this.setState({
      loading: false,
      game_name: "",
      course_id: 0,
      number_of_students: ""
    });
  };

  render() {
    const { show, onHide, courses } = this.props;
    const {
      game_name,
      loading,
      showError1,
      showError2,
      showError3,
      number_of_students,
      course_id
    } = this.state;

    return (
      <Modal
        show={show}
        dialogClassName="modal-dialog-instructor"
        onHide={onHide}
      >
        <Modal.Body>
          {showError1 === true && (
            <div className="alert alert-danger">
              <b>Game Name</b> is required!
            </div>
          )}
          {showError2 === true && (
            <div className="alert alert-danger">
              <b>Course</b> is required!
            </div>
          )}
          {showError3 === true && (
            <div className="alert alert-danger">
              <b>Number of students</b> is required!
            </div>
          )}
          <div className="table-responsive">
            <table className="table">
              <tbody>
                <tr className="border-none instructor-modal-row">
                  <td className="text-center">
                    <input
                      name="game_name"
                      value={game_name}
                      onChange={this.changeInput}
                      className="form-control"
                      placeholder="Game Name"
                    />
                  </td>
                </tr>
                <tr className="border-none instructor-modal-row">
                  <td className="text-center">
                    <select
                      name="course_id"
                      onChange={this.changeSelect}
                      value={course_id}
                    >
                      <option value="0">Select Course</option>
                      {courses.map((course, index) => (
                        <option key={index} value={course.id}>
                          {course.name}
                        </option>
                      ))}
                    </select>
                  </td>
                </tr>
                <tr className="border-none instructor-modal-row">
                  <td className="text-center">
                    <input
                      name="number_of_students"
                      value={number_of_students}
                      onChange={this.changeInput}
                      className="form-control"
                      placeholder="Input # of Students"
                    />
                  </td>
                </tr>
                <tr className="border-none instructor-modal-row">
                  <td>
                    <Button
                      bsStyle="orange"
                      onClick={this.submit}
                      block={true}
                      disabled={loading}
                    >
                      {loading ? "Loading..." : "Save"}
                    </Button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

export default CreateGameModal;



// WEBPACK FOOTER //
// ./src/instructor/components/create-game-modal.js